/**
 * Checkbox widget.
 */

import type { FunctionComponent } from 'preact'

interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  disabled?: boolean
}

export const Checkbox: FunctionComponent<CheckboxProps> = ({
  checked,
  onChange,
  label,
  disabled,
}) => {
  return (
    <label class="syv-checkbox-wrapper">
      <input
        type="checkbox"
        class="syv-checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange((e.target as HTMLInputElement).checked)}
      />
      {label && <span>{label}</span>}
    </label>
  )
}
